(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', async () => {
  const el = document.getElementById('language');
  console.log('[lang] element:', el);

  if (!el) {
    console.warn('[lang] #language not found, skipping');
    return;
  }

  const lang = el.value;
  console.log('[lang] value:', lang);

  const cartBefore = await fetch('/cart.js').then(r => r.json());
  console.log('[lang] cart before:', cartBefore.attributes);

  if (!cartBefore.attributes || !cartBefore.attributes.language) {
    const updated = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { language: lang } })
    }).then(r => r.json());

    console.log('[lang] cart after:', updated.attributes);
  }
});

  } catch(e) { console.error(e); }
})();
})();
